export default __webpack_public_path__ + "static/media/Zillow.4f878bf2.svg";